import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { NAV_LINKS, SITE, LOGO_SRC } from "../lib/content";

const scrollToId = (id) => {
  if (!id) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 80;
  window.scrollTo({ top, behavior: "smooth" });
};

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-ink-border bg-ink mt-24">
      <div className="container-editorial py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="eyebrow mb-4">Advisory</div>
          <img
            src={LOGO_SRC}
            alt="Kevin Tan"
            className="h-14 w-auto -ml-1"
            draggable={false}
          />
          <p className="mt-4 text-grey-soft text-sm tracking-wide">{SITE.role}</p>
          <p className="mt-1 text-grey-soft text-sm tracking-wide">{SITE.location}</p>
          <div className="hairline my-8 max-w-xs" />
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3 text-ivory/80">
              <Mail size={14} className="text-gold" />
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-gold transition-colors">
                {SITE.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-ivory/80">
              <Phone size={14} className="text-gold" />
              <a href={`tel:${SITE.mobile.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-gold transition-colors">
                {SITE.mobile}
              </a>
            </li>
            <li className="flex items-center gap-3 text-ivory/80">
              <MapPin size={14} className="text-gold" />
              <span>{SITE.location}</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-4">Navigate</div>
          <ul className="space-y-3">
            <li>
              <button
                type="button"
                onClick={() => scrollToId("")}
                data-testid="footer-nav-home"
                className="text-sm text-ivory/75 hover:text-gold transition-colors tracking-wide"
              >
                Home
              </button>
            </li>
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <button
                  type="button"
                  onClick={() => scrollToId(l.to)}
                  data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  className="text-sm text-ivory/75 hover:text-gold transition-colors tracking-wide"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button
                type="button"
                onClick={() => scrollToId("contact")}
                data-testid="footer-nav-contact"
                className="text-sm text-ivory/75 hover:text-gold transition-colors tracking-wide"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Engagement</div>
          <p className="text-sm text-grey-soft leading-relaxed">
            Advisory engagements are accepted selectively across mall development, repositioning, leasing strategy and mixed-use retail destinations.
          </p>
          <button
            type="button"
            onClick={() => scrollToId("contact")}
            data-testid="footer-cta-engage"
            className="mt-6 inline-flex items-center justify-center px-7 py-3 border border-gold text-ivory text-xs tracking-[0.22em] uppercase hover:bg-gold/10 transition-colors duration-300"
          >
            Engage Kevin
          </button>
        </div>
      </div>

      <div className="border-t border-ink-border">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[0.7rem] uppercase tracking-[0.26em] text-grey-deep">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </p>
          <p className="text-[0.7rem] uppercase tracking-[0.26em] text-grey-deep">
            Shopping Mall &amp; Retail Advisor · Kuala Lumpur
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
